import React, { useEffect, useState } from "react";

// bootstrap
import {
    Image
} from 'react-bootstrap'

// react redux
import { connect } from "react-redux";

// react router
import { Link } from "react-router-dom";

// styles
import {
	TopProductContainer,
	SectionTitle,
	SectionTitleSpan,
	ProductListContainer,
} from "../../styles/TopProduct"
import CategoriesContainer from '../../styles/CategoriesContainer';

// APIs
import { getCategoriesTree, cancelGetCategoriesTreeApi } from "utlis/Apis/Categories_API";

// app messages
import {
	UNKNOWN_ERROR_OCCURED,
	ERROR_WHILE__NAME,
} from "utlis/AppMessages/AppMessages";

// react toastify
import { toast } from "react-toastify";

// loading
import LoadingSkeleton from "./Categories__loadingSkeleton";

// no image found
import noImgFoundImg from 'assets/images/no-img.png'

function Categories(props) {
	// props
	const { commonToken } = props

	// consts
	const loadingIndicatorsCount = [1, 2, 3, 4, 5, 6]

	// states
	const [dataLoading, setDataLoading] = useState([]);
	const [categoriesList, setCategoriesList] = useState([]);

	// getting data
    useEffect(() => {
        // enable categories list loading
		setDataLoading(true);

		// getting categories tree
		getCategoriesTree(commonToken ?? "").then((res) => {
			// disabling categories list loading
			setDataLoading(false);

			const catsData = res?.data;

			// if request is success
			if (catsData?.success) {
				// settings categories
				setCategoriesList(catsData.data);
			}

			// if request is not succeed
			if (catsData?.error) {
				// dismissing all the previous toasts first
				toast.dismiss();

				// showing the error message
				toast.error(UNKNOWN_ERROR_OCCURED, {
					autoClose: 2500,
					onClose: () => { },
				});
			}
		}).catch((err) => {
			console.log(`${ERROR_WHILE__NAME} getCategoriesTree `, err.message);

			// dismissing all the previous toasts first
			toast.dismiss();

			// showing the error message
			toast.error(UNKNOWN_ERROR_OCCURED, {
				autoClose: 2500,
				onClose: () => {
					// hide loading
					setDataLoading(false)
				},
			});
		});

        return () => {
            cancelGetCategoriesTreeApi && cancelGetCategoriesTreeApi()
        }
    }, [commonToken])

	return (
		<CategoriesContainer>
			<div className="container">
				<SectionTitle className="page-title">
					<SectionTitleSpan>
						Explore
					</SectionTitleSpan>
					<span className="text-capitalize">All Categories</span>
				</SectionTitle>

				<ProductListContainer className="product-list">
					<div className="row justify-content-center">
						{
							dataLoading ? (
								<div className="loading-container row">
									{
										(loadingIndicatorsCount?.length) ? loadingIndicatorsCount.map(item => (
											<React.Fragment key={item}>
												<LoadingSkeleton />
											</React.Fragment>
										)) : null
									}
								</div>
							) : (
								<React.Fragment>
									{
										categoriesList?.length ? categoriesList.map(item => {
											const linkTo = item?.sub_categories?.length ? `/category/${item.category_url}?id=${item.category_id}` : `/shop/${item.category_url}?id=${item.category_id}`

											return (
												<div key={item.category_id} className="item col-md-4 col-lg-3">
													<Link to={linkTo} className="inner text-center d-block text-decoration-none">
														{/* img sec */}
														<div className="img-sec-outer">
															<div className="img-sec" data-item={item.image}>
																<Image src={item.image || noImgFoundImg} fluid onLoad={ev => ev.target.parentNode.classList.add("loaded")} className="img-fluid-height" />
															</div>
														</div>

														{/* text sec */}
														<div className="text-sec mt-3">
															<p className="cat-name mb-0 st-fw-600 st-fs-18 text-uppercase">
																{item.category_name}
															</p>
														</div>
													</Link>
												</div>
											);
										}) : (
											<React.Fragment>
												<div className="text-center py-2">
													No categories found
												</div>
											</React.Fragment>
										)
									}
								</React.Fragment>
							)
						}
					</div>
				</ProductListContainer>
			</div>
		</CategoriesContainer>
	);
}

const getDataFromStore = (state) => {
	return {
		commonToken: state.auth.commonToken,
	};
};

export default connect(getDataFromStore, null)(Categories);